export default "__VITE_ASSET__46f9ca72__"